// Mock data for the Growth & Performance Marketing Website

export const navigationItems = [
  { id: 'services', label: 'What We Do' },
  { id: 'how-we-work', label: 'The Process' },
  { id: 'proof', label: 'The Proof' },
  { id: 'about', label: 'Who We Are' },
  { id: 'contact', label: 'Let\'s Talk' },
];

export const heroStats = [
  { value: '10+', label: 'Years Deep' },
  { value: '150+', label: 'Funnels Built' },
  { value: '3.2x', label: 'Avg. ROAS' },
];

export const painPoints = [
  {
    id: 1,
    emoji: '🎯',
    title: 'Scattered shots',
    description: 'Ads here. Website there. Strategy... where?',
  },
  {
    id: 2,
    emoji: '📊',
    title: 'Data overload',
    description: 'Dashboards everywhere. Insights nowhere.',
  },
  {
    id: 3,
    emoji: '💸',
    title: 'Budget black holes',
    description: 'Money goes in. Magic doesn\'t come out.',
  },
  {
    id: 4,
    emoji: '🔧',
    title: 'Tool fatigue',
    description: '47 subscriptions. Zero systems.',
  },
];

export const services = [
  {
    id: 1,
    title: 'Performance Marketing',
    tagline: 'Ads that actually work',
    description: 'We don\'t just run ads. We engineer revenue machines.',
    color: 'from-rose-500 to-orange-500',
    bgColor: 'bg-rose-50',
    capabilities: [
      'Google Ads mastery',
      'Meta Ads wizardry',
      'LinkedIn B2B magic',
      'TikTok for the bold',
    ],
  },
  {
    id: 2,
    title: 'Conversion Assets',
    tagline: 'Pixels that convert',
    description: 'Beautiful is nothing without action. We build both.',
    color: 'from-amber-500 to-yellow-500',
    bgColor: 'bg-amber-50',
    capabilities: [
      'Websites that sell',
      'Landing pages that land',
      'Funnels that flow',
      'Creatives that click',
    ],
  },
  {
    id: 3,
    title: 'Strategy & Insights',
    tagline: 'Brains behind the beauty',
    description: 'Data-driven decisions. Gut feelings backed by numbers.',
    color: 'from-emerald-500 to-teal-500',
    bgColor: 'bg-emerald-50',
    capabilities: [
      'Funnel diagnostics',
      'Growth roadmaps',
      'Analytics setup',
      'Competitor recon',
    ],
  },
  {
    id: 4,
    title: 'Marketing Ops',
    tagline: 'Systems > chaos',
    description: 'Automate the boring. Focus on the brilliant.',
    color: 'from-sky-500 to-indigo-500',
    bgColor: 'bg-sky-50',
    capabilities: [
      'Automation flows',
      'CRM integration',
      'Workflow design',
      'AI-powered ops',
    ],
  },
];

export const processSteps = [
  {
    id: 1,
    step: '01',
    title: 'Audit',
    subtitle: 'We dig deep',
    description: 'No fluff. Just truth. We tear apart your funnel to find what\'s broken and what\'s brilliant.',
    visual: '🔍',
  },
  {
    id: 2,
    step: '02',
    title: 'Strategize',
    subtitle: 'We plot the course',
    description: 'A clear roadmap with priorities that make sense. Quick wins + long-term plays.',
    visual: '🗺️',
  },
  {
    id: 3,
    step: '03',
    title: 'Execute',
    subtitle: 'We make it happen',
    description: 'Hands-on building. From ads to landing pages, we ship fast and ship right.',
    visual: '🚀',
  },
  {
    id: 4,
    step: '04',
    title: 'Optimize',
    subtitle: 'We never stop',
    description: 'Growth isn\'t a one-time thing. We iterate, test, and push for more.',
    visual: '📈',
  },
];

export const proofPoints = [
  {
    id: 1,
    metric: '3.2x',
    label: 'Average ROAS',
    description: 'Return on ad spend across client accounts',
  },
  {
    id: 2,
    metric: '47%',
    label: 'Conversion Lift',
    description: 'Average improvement in landing page conversions',
  },
  {
    id: 3,
    metric: '2.1x',
    label: 'Lead Volume',
    description: 'Increase in qualified leads within 90 days',
  },
  {
    id: 4,
    metric: '-34%',
    label: 'CAC Reduction',
    description: 'Average decrease in customer acquisition cost',
  },
];

export const testimonials = [
  {
    id: 1,
    quote: 'They turned our chaotic marketing into a growth machine.',
    author: 'Startup Founder',
    role: 'Series A SaaS',
  },
  {
    id: 2,
    quote: 'Finally, an agency that actually understands performance.',
    author: 'Marketing Director',
    role: 'E-commerce Brand',
  },
];

export const spendRanges = [
  { value: 'under-5k', label: 'Under $5K/mo' },
  { value: '5k-15k', label: '$5K - $15K/mo' },
  { value: '15k-50k', label: '$15K - $50K/mo' },
  { value: 'over-50k', label: '$50K+/mo' },
  { value: 'not-sure', label: 'Let\'s figure it out' },
];

export const founderInfo = {
  name: 'The Human Behind VizBuilds',
  experience: '10+ years',
  tagline: 'Not an agency. A growth partner.',
  description: 'Hands-on execution across ads, funnels, analytics, and optimization. No outsourcing. No guesswork. Just systems that perform.',
  values: ['Performance-obsessed', 'Data-driven', 'Results-focused'],
};

export const marqueeItems = [
  'Performance Marketing',
  '•',
  'Conversion Optimization',
  '•',
  'Growth Strategy',
  '•',
  'Paid Social',
  '•',
  'Landing Pages',
  '•',
  'Marketing Automation',
  '•',
];
